<form
  class="mr-5 ml-5 mt-5 mb-3"
  [formGroup]="completaForm"
  (ngSubmit)="goPaso()"
>
  <!-- Informacion prestador -->
  <section class="row border-bottom mb-4">
    <section class="col-12 px-0">
      <app-ayudas
        [ayuda]="
          ayudaService.completaInformacionEstablecimiento(
            datoSolicitudSharedModel.tipo_solicitud,
            completaForm.getRawValue().sub_categoria_id,
            rnt.estado_rnt_id,
            rnt.estado_solicitud_id
          )
        "
      ></app-ayudas>
      <header class="row d-flex align-items-center">
        <figure>
          <img
            src="../../../../../../../../assets/icons/info-prestador.png"
            class="d-inline-block p-2 rounded-circle"
            alt=""
            height="50"
          />
        </figure>
        <div>
          <h2 class="h5 pb-1">Información prestador</h2>
        </div>
      </header>

      <!-- Informacion General -->
      <div class="card mb-3" style="background-color: #f5f5f5">
        <div class="card-body">
          <p class="fs-5">
            <strong>Información General</strong>
          </p>

          <div class="row">
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Razón social</label>
              <p>
                <strong>{{ prestador.razon_social }}</strong>
              </p>
            </div>

            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">NIT</label>
              <p>
                <strong>{{ prestador.nit }}</strong>
              </p>
            </div>

            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Representante legal</label>
              <p>
                <strong>{{
                  establecimiento.nombre_gerente ||
                    establecimiento.nombre_representante_legal
                }}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Notificaciones -->
      <div class="card mb-3" style="background-color: #f5f5f5">
        <div class="card-body">
          <p class="fs-5">
            <strong>Notificaciones</strong>
          </p>

          <div class="row">
            <div class="col-md-3">
              <label class="small text-secondary mb-0"
                >Correo electrónico</label
              >
              <p>
                <strong class="fw-semibold text-break">
                  {{ prestador.correo_electronico_fiscal }}
                </strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small text-secondary mb-0">Departamento</label>
              <p>
                <strong class="fw-semibold text-break">
                  {{ establecimiento.desc_dpto_notificacion }}
                </strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small text-secondary mb-0">Municipio</label>
              <p>
                <strong class="fw-semibold text-break">
                  {{ establecimiento.desc_municipio_notificacion }}
                </strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small text-secondary mb-0">Dirección</label>
              <p>
                <strong class="fw-semibold text-break">
                  {{ establecimiento.direccion_notificacion }}
                </strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small text-secondary mb-0">Teléfono</label>
              <p>
                <strong class="fw-bold text-break">
                  {{ establecimiento.numero_telefonico_notificacion }}
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Datos Adicionales -->
      <div class="card mb-3" style="background-color: #f5f5f5">
        <div class="card-body">
          <p class="fs-5">
            <strong>Datos Adicionales</strong>
          </p>

          <div class="row">
            <div class="col-sm-12 col-md-3">
              <label class="small text-secondary mb-0"
                >Último Año Renovación Matricula Mercantil</label
              >
              <p>
                <strong>{{ prestador.ultimo_ano_renovado }}</strong>
              </p>
            </div>

            <div class="col-sm-12 col-md-3">
              <label class="small text-secondary mb-0">Patrimonio neto</label>
              <p>
                <strong>{{
                  prestador.patrimonio_neto | currency: "COP"
                }}</strong>
              </p>
            </div>

            <div class="col-sm-12 col-md-3">
              <label class="small text-secondary mb-0"
                >Número de empleados</label
              >
              <p>
                <strong>{{ establecimiento.numero_empleados }}</strong>
              </p>
            </div>

            <div class="col-sm-12 col-md-3 text-right">
              <label class="small text-secondary mb-0"
                >Actividad económica</label
              ><br />
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="verActividades('prestador')"
              >
                Ver actividades
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>

  <section
    class="row border-bottom mb-2"
    *ngIf="informacionUsuarioDepositario != null"
  >
    <section class="col-12 px-0">
      <header class="col-12 row d-flex align-items-center">
        <figure>
          <img
            src="../../../../../../../../assets/icons/info-establecimiento.png"
            class="d-inline-block p-2 rounded-circle"
            alt=""
            height="50"
          />
        </figure>
        <div>
          <h2 class="h5 pb-1">Información usuario depositario</h2>
        </div>
      </header>
      <footer class="row">
        <div class="col-sm-12 col-md-4">
          <label class="small text-secondary mb-0">Nombre</label>
          <p>
            <strong>{{
              informacionUsuarioDepositario.nombre_usuario_provisional +
                " " +
                informacionUsuarioDepositario.apellido_usuario_provisional
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-4">
          <label class="small text-secondary mb-0">Número identificación</label>
          <p>
            <strong>{{
              informacionUsuarioDepositario.numero_identificacion_usuario_provisional
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-4">
          <label class="small text-secondary mb-0">Cargo</label>
          <p>
            <strong>{{
              informacionUsuarioDepositario.cargo_usuario_provisional
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-4">
          <label class="small text-secondary mb-0">Correo electrónico</label>
          <p>
            <strong>{{
              informacionUsuarioDepositario.correo_usuario_provisional
            }}</strong>
          </p>
        </div>
      </footer>
    </section>
  </section>

  <!-- Informacion Establecimiento/Inmueble/Guia -->
  <section class="row border-bottom mb-4">
    <section class="col-12 px-0">
      <header class="row d-flex align-items-center">
        <figure>
          <img
            src="../../../../../../../../assets/icons/info-establecimiento.png"
            class="d-inline-block p-2 rounded-circle"
            alt=""
            height="50"
          />
        </figure>
        <div>
          <h2 class="h5 pb-1">Información establecimiento</h2>
        </div>
      </header>

      <!-- Establecimiento -->
      <div class="card mb-3" style="background-color: #f5f5f5">
        <div class="card-body">
          <p class="fs-5">
            <strong>Establecimiento</strong>
          </p>

          <div class="row">
            <div class="col-sm-12 col-md-4">
              <label class="small mb-0">Nombre</label>
              <p>
                <strong>{{ establecimiento.razon_social }}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Contacto -->
      <div class="card mb-3" style="background-color: #f5f5f5">
        <div class="card-body">
          <p class="fs-5">
            <strong>Contacto</strong>
          </p>

          <div class="row">
            <div class="col-md-3">
              <label class="small mb-0">Correo electrónico</label>
              <p>
                <strong>{{ establecimiento.correo_electronico }}</strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small mb-0">Departamento</label>
              <p>
                <strong>{{ establecimiento.desc_dpto }}</strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small mb-0">Municipio</label>
              <p>
                <strong>{{ establecimiento.desc_municipio }}</strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small mb-0">Dirección</label>
              <p>
                <strong>{{ establecimiento.direccion_comercial }}</strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small mb-0">Teléfono 1</label>
              <p>
                <strong>{{ establecimiento.numero_celular }}</strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small mb-0">Teléfono 2</label>
              <p>
                <strong>{{ establecimiento.numero_telefonico }}</strong>
              </p>
            </div>

            <div class="col-md-3">
              <label class="small mb-0">Fax</label>
              <p>
                <strong>{{ establecimiento.fax }}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Informacion adicional -->
      <div class="card mb-3" style="background-color: #f5f5f5">
        <div class="card-body">
          <p class="fs-5">
            <strong>Información adicional</strong>
          </p>

          <div class="row">
            <div class="col-md-3">
              <label class="small mb-0"
                >Último Año Renovación Matricula Mercantil</label
              >
              <p>
                <strong>{{ establecimiento.ultimo_anio_renovado }}</strong>
              </p>
            </div>

            <div class="col-md-9 text-right">
              <label class="small text-secondary mb-0"
                >Actividad económica</label
              ><br />
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="verActividades('establecimiento')"
              >
                Ver actividades
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>

  <header class="col-12 mb-3">
    <h2 class="h6 font-weight-bold">Completa esta información</h2>
  </header>

  <ng-container *ngIf="boolCactegoriaux; else norma_seguencia">
    <section class="col-12 form-row">
      <div class="col-sm-12 col-md-4 form-group">
        <label for="categoria_id" class="small text-secondary required"
          >Categoría</label
        >
        <select
          id="categoria_id"
          formControlName="categoria_id"
          class="form-control"
          (change)="onCategoria()"
        >
          <option class="" [ngValue]="null" selected="true">Seleccione</option>
          <ng-container *ngFor="let item of categorias">
            <option [ngValue]="item.categoria_id">
              {{ item.descripcion }}
            </option>
          </ng-container>
        </select>
      </div>
      <div class="col-1"></div>
      <div class="col-sm-12 col-offset-md-1 col-md-7 form-group">
        <label for="sub_categoria_id" class="small text-secondary required"
          >Subcategoría</label
        >
        <select
          id="sub_categoria_id"
          formControlName="sub_categoria_id"
          class="form-control"
          (change)="onSubCategoria($event.target.value)"
        >
          <option class="" [ngValue]="null" selected="true">Seleccione</option>
          <ng-container *ngFor="let item of subCategorias">
            <option [ngValue]="item.sub_categoria_id">
              {{ item.descripcion }}
            </option>
          </ng-container>
        </select>
      </div>
      <div class="col"></div>
    </section>
  </ng-container>

  <ng-template #norma_seguencia>
    <ng-container
      *ngIf="
        datoSolicitudSharedModel.tipo_solicitud === tipo_renovacion ||
        (datoSolicitudSharedModel.data.estado_rnt_id == estado_suspendido_por_no_renovar &&  
        datoSolicitudSharedModel.tipo_solicitud == tipo_reactivacion) ||
          datoSolicitudSharedModel.estado_solicitud === estado_devuelto ||
          datoSolicitudSharedModel.tipo_solicitud === tipo_edicion ||
          (rnt && rnt.es_devuelta);
        else no_tipo_renovacion
      "
    >
      <section class="col-12 form-row">
        <div class="col-sm-12 col-md-4 form-group">
          <label for="categoria_id" class="small text-secondary"
            >Categoría</label
          >
          <input
            id="categoria_id"
            formControlName="desc_categoria"
            class="form-control"
          />
        </div>
        <div class="col-1"></div>
        <ng-container
          *ngIf="
            datoSolicitudSharedModel.tipo_solicitud === tipo_edicion ||
            (datoSolicitudSharedModel.data.estado_rnt_id == estado_suspendido_por_no_renovar &&  
            datoSolicitudSharedModel.tipo_solicitud == tipo_reactivacion) ||
              datoSolicitudSharedModel.tipo_solicitud === tipo_renovacion;
            else no_solicitud_actualizacion
          "
        >
          <div class="col-sm-12 col-offset-md-1 col-md-7 form-group">
            <label for="sub_categoria_id" class="small text-secondary required"
              >Subcategoría</label
            >
            <select
              id="sub_categoria_id"
              formControlName="sub_categoria_id"
              class="form-control"
              (change)="onSubCategoria($event.target.value)"
            >
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <ng-container *ngFor="let item of subCategorias">
                <option [ngValue]="item.sub_categoria_id">
                  {{ item.descripcion }}
                </option>
              </ng-container>
            </select>
          </div>
        </ng-container>
        <ng-template #no_solicitud_actualizacion>
          <div class="col-sm-12 col-offset-md-1 col-md-7 form-group">
            <label for="sub_categoria_id" class="small text-secondary"
              >Subcategoría</label
            >
            <input
              id="sub_categoria_id"
              formControlName="desc_sub_categoria"
              class="form-control"
            />
          </div>
        </ng-template>
        <div class="col"></div>
      </section>
    </ng-container>
    <ng-template #no_tipo_renovacion>
      <section class="col-12 form-row">
        <div class="col-sm-12 col-md-4 form-group">
          <label for="categoria_id" class="small text-secondary required"
            >Categoría</label
          >
          <select
            id="categoria_id"
            formControlName="categoria_id"
            class="form-control"
            (change)="onCategoria()"
          >
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <ng-container *ngFor="let item of categorias">
              <option [ngValue]="item.categoria_id">
                {{ item.descripcion }}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="col-1"></div>
        <div class="col-sm-12 col-offset-md-1 col-md-7 form-group">
          <label for="sub_categoria_id" class="small text-secondary required"
            >Subcategoría</label
          >
          <select
            id="sub_categoria_id"
            formControlName="sub_categoria_id"
            class="form-control"
            (change)="onSubCategoria($event.target.value)"
          >
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <ng-container *ngFor="let item of subCategorias">
              <option [ngValue]="item.sub_categoria_id">
                {{ item.descripcion }}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="col"></div>
      </section>
    </ng-template>
  </ng-template>

  <footer class="text-right p-3">
    
    
    <button
            *ngIf="(datoSolicitudSharedModel.data.estado_rnt_id == estado_suspendido_por_no_renovar &&  
            datoSolicitudSharedModel.tipo_solicitud == tipo_reactivacion)"
            type="button"
            class="btn btn-outline-primary
                  paso-capacidad-info-btn-inicio mr-2"
            (click)="onRegresarPaso()"
          >
            Atras
          </button>
    <button
      type="submit"
      class="btn btn-primary paso-completa-info-btn-inicio"
      [disabled]="!completaForm.valid || hasRequiredActions"
    >
      Siguiente
    </button>
  </footer>
</form>
